import Model from "@/models/Model";
import File from "@/models/File";
import Resource from "@/models/Resource";
import CompletedHomework from "@/models/CompletedHomework";

export default class User extends Model {
    resource() {
        return "users";
    }

    files() {
        return this.hasMany(File);
    }

    assignedResources() {
        return this.hasMany(Resource);
    }

    completedHomework() {
        return this.hasMany(CompletedHomework);
    }

    name(firstNameOnly) {
        if (firstNameOnly) {
            return this.first_name?.length
                ? this.first_name
                : this.display_name;
        } else {
            let fullname = this?.first_name?.length
                ? this.first_name + " " + this.last_name
                : null;

            return fullname && this.display_name !== fullname
                ? fullname + " (" + this.display_name + ")"
                : this.display_name;
        }
    }

    avatar(){
        return this.related?.avatar?.url
            ? this.related.avatar.url
            : "https://avatars.j2e.com/15-29-50-80-%23ffffff-%23b3b3b3.svg";
    }
}
